module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "rule"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v("活动规则")]), _vm._v(" "), _c('span', [_vm._v("分享活动页面至微信群或朋友圈，即可与好友一起领取有道词典VIP会员")]), _vm._v(" "), _c('span', [_vm._v("每人可免费领取1个月VIP；6位好友通过你分享的页面成功领取VIP，你将可领取6个月VIP")]), _vm._v(" "), _c('span', [_vm._v("6个月VIP可以与1个月VIP叠加兑换，兑换第二个VIP码时需待上一VIP时限过期")]), _vm._v(" "), _c('span', [_vm._v("VIP码即日起至2019.06.30有效，请在有效期内兑换")]), _vm._v(" "), _c('span', [_vm._v("兑换路径：打开“有道词典”登录-我的-会员中心-兑换会员-输入VIP兑换码")])]), _vm._v(" "), _c('p', [_vm._v("Jirin 21 / Shin-Jirin, Japanese-Chinese EditionCopyright © 1993, 1999"), _c('br'), _vm._v(" by SANSEIDO CO., LTD.& Foreign Language Teaching and Research Publishing Co.,Ltd.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cdba4b5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rule.vue
// module id = 37
// module chunks = 1 2